module.exports = new __parcel__URL__("6916.55af289c.jpg").toString();